
import { defineComponent } from 'vue'

export default defineComponent({
  mounted() {
    // eslint-disable-next-line prefer-destructuring
    // const eid = this.$route.query.eid
    // eslint-disable-next-line prefer-destructuring
    // const event = this.$route.query.event
    // if (eid) {
    // }
  },
})
